export default __webpack_public_path__ + "static/media/ic_polygon.1b3a2032.svg";